import type { RatingCardFragmentFragment } from '@packages/gql/generated/shopping/graphql';

export type RatingCardResponseProps = {
  /**
   * data - the data needed to render the component
   */
  data: NonNullable<RatingCardFragmentFragment['responses']>[number];
  /**
   * label - the label that is placed beneath the avatar icon
   */
  label: string;
};

/**
 * The RatingCardResponse component displays the a response from the customer service to the rating
 */
export const RatingCardResponse = ({
  data: { description, title },
  label,
  ...props
}: RatingCardResponseProps) => (
  <div className="border-color-grey rounded border p-1.5" {...props}>
    <div className="flex flex-row items-center gap-1">
      <span className="bg-color-grey-light box-content inline-block h-3 w-3 rounded-full p-[3px]">
        <span className="icon-emp-service-consulting inline-block h-full w-full" />
      </span>
      <div className="text-size-body2 font-bold">{label}</div>
    </div>
    <div className="text-size-body2 mt-1">
      {title.length ? <div className="font-semibold">{title}</div> : null}
      <div>{description}</div>
    </div>
  </div>
);
